import colors from '@/design/colors';
import { HeadingSmall } from '@/design/typography';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;

  /* Typography */
  ${HeadingSmall(14)}

  /* Colors */
  color: ${colors.blackAlpha100};
`;

export const Badge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 18px;
  opacity: 1;
  border-radius: 30px;
  gap: 10px;
  padding-right: 8px;
  padding-left: 8px;

  color: ${colors.white};
`;

export const NumeratorBadge = styled(Badge)`
  background-color: ${colors.purple100};
`;

export const DenominatorBadge = styled(Badge)`
  background-color: ${colors.gray300};
`;
